import React from "react";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Mano de Obra Directa
import RSemanal from "pages/ManoDeObra/Reporte_semanal";
import PuestosCarga from "pages/ManoDeObra/carga";
import ReportesMDO from "pages/ManoDeObra/Reportes";

//Mano de Obra InDirecta
import {ReporteMOI} from "pages/ManoDeIndirecta/Reportes";
import {IngresoMOI} from "pages/ManoDeIndirecta/ingreso";

//Combustibles
import Combustibles from "pages/Combustible";
import Eficiencias from "pages/Combustible/eficiencias";
//ConfigPeriodo
import ConfigPeriodo from "pages/ConfigPeriodo";


//Repuestos llantas y lubricantes
import Repu_lub_llan from "pages/Repu_lub_llan";

//Tarifas
import ReportesTarifas from "pages/Tarifas/Reportes";
import TarifasConfigs from "pages/Tarifas/Configuracion";




//Unidades
import UnidadesCarga from "pages/Unidades/Carga";
import UnidadesResumenes from "pages/Unidades/Reportes";
import UnidadesHistoricas from "pages/Unidades/Historico";

//Rubros
import Seguros from "pages/Rubros/seguros";
import Depreciaciones from "pages/Rubros/depreciaciones";
import Rentas from "pages/Rubros/rentas";
import Comunicaciones from "pages/Rubros/comunicaciones";
import Viaticos from "pages/Rubros/viaticos";
import Sinternos from "pages/Rubros/serviciosinternos";
// import Sitraslados from "pages/Rubros/sitraslados";

//Digiforms
import DigiformsMO from "pages/DigiForms/MO";
import DigiformsMQ from "pages/DigiForms/MQ";


const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //Mano de Obra directa
  { path: "/mod/semanal", component: <RSemanal /> },
  { path: "/mod/ingresopuestos", component: <PuestosCarga /> },
  { path: "/mod/Reportes", component: <ReportesMDO /> },

  //Mano de Obra indirecta
  { path: "/moi/reportes", component: <ReporteMOI /> },
  { path: "/moi/ingreso", component: <IngresoMOI /> },

  //Unidades
  { path: "/unidades/carga", component: <UnidadesCarga /> },
  { path: "/unidades/resumenes", component: <UnidadesResumenes /> },
  { path: "/unidades/historicas", component: <UnidadesHistoricas /> },

  //Tarifas
  { path: "/tarifas/reportes", component: <ReportesTarifas /> },
  { path: "/tarifas/configuraciones", component: <TarifasConfigs /> },

  //Combustibles
  { path: "/combustible", component: <Combustibles /> },
  { path: "/combustible/eficiencia", component: <Eficiencias /> },

  //Home
  { path: "/", component: <Dashboard /> },

  //Rubros
  { path: "/seguros", component: <Seguros /> },
  { path: "/depreciaciones", component: <Depreciaciones /> },
  { path: "/rentas", component: <Rentas /> },
  { path: "/comunicaciones", component: <Comunicaciones /> },
  { path: "/viaticos", component: <Viaticos /> },
  { path: "/sinternos", component: <Sinternos /> },

//Repuestos y lubricantes
  { path: "/repuestosylubricantes", component: <Repu_lub_llan /> },

  //Configurador de periodos
  { path: "/periodoconfig", component: <ConfigPeriodo /> },
  //Digiforms
  { path: "/digiforms/mo", component: <DigiformsMO /> },
  { path: "/digiforms/mq", component: <DigiformsMQ /> }
];

  
const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // { path: "/forgot-password", component: <ForgetPwd /> },
  // { path: "/register", component: <Register /> },

 

];

export { userRoutes, authRoutes };
